<div class="field-display">
  <span class="field-value">{{displayText}}</span>
</div>
